import {Component, OnInit, TemplateRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {CrudComponent} from '../../../../shared/components/crud/crud.component';
import {BaseResponse} from '../../../../shared/models/respose/BaseResponse';
import {PaginatedDataResponse} from '../../../../shared/models/respose/PaginatedDataResponse';
import {ExperienceYear} from '../../../../shared/models/ExperienceYear';
import {ExperienceYearService} from '../../../services/experience-year.service';
import {Pagination} from '../../../../shared/models/Pagination';

@Component({
  selector: 'app-experience-years',
  templateUrl: './experienceYears.component.html',
  styleUrls: ['./experienceYears.component.css']
})
export class ExperienceYearsComponent extends CrudComponent {
  public paginatedResponse: PaginatedDataResponse<ExperienceYear> = new PaginatedDataResponse<ExperienceYear>(0, [], 0, 0, 0);

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private service: ExperienceYearService
  ) {
    super(modalService, fb);
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null],
      name: ['', [Validators.required]]
    });
    this.formSearch = this.fb.group({
      name: ['']
    });
    this.updateList({page: 1, elements: this.elements});
  }

  onSubmit({value, valid}: { value: ExperienceYear, valid: boolean }): void {
    if (valid) {
      if (value.id) {
        this.callUpdate(value);
      } else {
        this.callRegister(value);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  onFind({value, valid}: { value: any, valid: boolean }): void {
    this.updateList({page: 1, elements: this.elements});
  }

  updateList(pagination: Pagination = {page: 1, elements: this.elements}): void{
    const experienceYear: ExperienceYear = this.formSearch.value;
    this.service.getPaginatedList(pagination.elements, pagination.page, experienceYear, this.order).subscribe(
      (response: BaseResponse<PaginatedDataResponse<ExperienceYear>>) => {
        this.paginatedResponse = response.data;
      }
    );
  }

  openTrashModal(content: TemplateRef<any>, experienceYear: ExperienceYear): void {
    this.modalService.open(content, {ariaLabelledBy: 'appointment-detail-modal-basic-title'}).result.then((result) => {
      this.service.deleteItem(experienceYear.id).subscribe(() => this.updateList({page: 1, elements: this.elements}));
    }, (reason) => {
    });
  }

  edit(experienceYear: ExperienceYear): void {
    this.form.setValue(
      {
        id: experienceYear.id,
        name: experienceYear.name
      }
    );
    this.showHideForm();
  }

  callRegister(experienceYear: ExperienceYear): void {
    this.service.register(experienceYear).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }

  callUpdate(experienceYear: ExperienceYear): void {
    this.service.updateItem(experienceYear, experienceYear.id).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }
}
